import { getSVGReferenceType } from "../../spinoffs/formatSVGReference";
export const MARKER_PROPERTIES = [
    "marker",
    "markerStart",
    "markerMid",
    "markerEnd"
];
export const createMarkerId = (markerProperty, markerName) => {
    return markerProperty + markerName;
};
export const getSVGMarkerReferenceType = (markerName) => {
    return getSVGReferenceType(markerName, ["string", "localIRI", "nonLocalIRI"]);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01hcmtlci9oZWxwZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxtQkFBbUIsRUFBRSxNQUFNLG1DQUFtQyxDQUFDO0FBR3hFLE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFrQztJQUM5RCxRQUFRO0lBQ1IsYUFBYTtJQUNiLFdBQVc7SUFDWCxXQUFXO0NBQ1osQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGNBQWMsR0FBRyxDQUM1QixjQUE4QixFQUM5QixVQUFrQixFQUNsQixFQUFFO0lBQ0YsT0FBTyxjQUFjLEdBQUcsVUFBVSxDQUFDO0FBQ3JDLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLHlCQUF5QixHQUFHLENBQUMsVUFBa0IsRUFBRSxFQUFFO0lBQzlELE9BQU8sbUJBQW1CLENBQUMsVUFBVSxFQUFFLENBQUMsUUFBUSxFQUFFLFVBQVUsRUFBRSxhQUFhLENBQUMsQ0FBQyxDQUFDO0FBQ2hGLENBQUMsQ0FBQyJ9